module.exports = __webpack_public_path__ + "img/icon-tarjeta.86857b56.svg";